import { Icon } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { TouchableOpacity, View } from 'react-native';

import { LinkNoDecoration } from 'components/app-header/styled';
import { modalHeaderStyles } from 'components/card-modal-header';
import { Logo } from 'components/logo';
import { useDismissAndReplace } from 'navigation/hooks/use-dismiss-and-navigate';
import { routes } from 'utils/routing';

interface IWalmartHeader {
  authzCode?: string | string[] | null;
  disabled?: boolean;
}

export const WalmartHeader = ({ authzCode, disabled = false }: IWalmartHeader) => {
  const dismissAndReplace = useDismissAndReplace();
  const router = useRouter();

  if (disabled) {
    return null;
  }

  return (
    <View style={modalHeaderStyles.headerContainer}>
      <View style={modalHeaderStyles.headerFlexStart}></View>
      <LinkNoDecoration onPress={() => dismissAndReplace(routes.base)}>
        <Logo />
      </LinkNoDecoration>
      <View style={modalHeaderStyles.headerFlexEnd}>
        <TouchableOpacity
          onPress={() => (router.canGoBack() ? router.back() : dismissAndReplace(routes.base))}
          testID="modal-back-button"
          hitSlop={15}
        >
          <Icon variant="cancel" />
        </TouchableOpacity>
      </View>
    </View>
  );
};
